module.exports = __webpack_public_path__ + "img/gq.edbab32d.svg";